module.exports = __webpack_public_path__ + "static/media/ZoomLogo.61912b26.png";